'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axios = require('axios');
var querystring = require('querystring');
var BigNumber = require('bignumber.js');

var _require = require('wyvern-js'),
    WyvernProtocol = _require.WyvernProtocol;

var feeRecipient = '0x11db40014E2985c360B3f2A4bA350fBf104Dc326';

var errors = {
  INVALID_HASH: 'invalid_hash'
};

var assetFromJSON;
var settlementFromJSON;
var orderFromJSON;

assetFromJSON = function assetFromJSON(asset) {
  if (asset.orders) {
    asset.orders = asset.orders.map(orderFromJSON);
  }
  return asset;
};

settlementFromJSON = function settlementFromJSON(settlement) {
  settlement.price = new BigNumber(settlement.price);
  if (settlement.order) {
    settlement.order = orderFromJSON(settlement.order);
  }
  return settlement;
};

orderFromJSON = function orderFromJSON(order) {
  var hash = WyvernProtocol.getOrderHashHex(order);
  if (hash !== order.hash) {
    throw new Error(errors.INVALID_HASH);
  }
  var fromJSON = {
    hash: order.hash,
    cancelledOrFinalized: order.cancelledOrFinalized,
    markedInvalid: order.markedInvalid,
    metadata: order.metadata,
    exchange: order.exchange,
    maker: order.maker,
    taker: order.taker,
    makerFee: new BigNumber(order.makerFee),
    takerFee: new BigNumber(order.takerFee),
    feeRecipient: order.feeRecipient,
    side: JSON.parse(order.side),
    saleKind: JSON.parse(order.saleKind),
    target: order.target,
    howToCall: JSON.parse(order.howToCall),
    calldata: order.calldata,
    replacementPattern: order.replacementPattern,
    staticTarget: order.staticTarget,
    staticExtradata: order.staticExtradata,
    paymentToken: order.paymentToken,
    basePrice: new BigNumber(order.basePrice),
    extra: new BigNumber(order.extra),
    listingTime: new BigNumber(order.listingTime),
    expirationTime: new BigNumber(order.expirationTime),
    salt: new BigNumber(order.salt),
    v: parseInt(order.v),
    r: order.r,
    s: order.s
  };
  if (order.asset) fromJSON.asset = assetFromJSON(order.asset);
  if (order.settlement) fromJSON.settlement = settlementFromJSON(order.settlement);
  return fromJSON;
};

var objToQuery = function objToQuery(obj) {
  if (obj) {
    return '?' + querystring.stringify(obj);
  } else {
    return '';
  }
};

var WyvernExchange = function () {
  function WyvernExchange(endpoint) {
    (0, _classCallCheck3.default)(this, WyvernExchange);

    this.endpoint = endpoint;
  }

  (0, _createClass3.default)(WyvernExchange, [{
    key: 'settlements',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(query) {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get(this.endpoint + '/v0/settlements' + objToQuery(query));

              case 2:
                response = _context.sent;
                return _context.abrupt('return', response.data.result.map(settlementFromJSON));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function settlements(_x) {
        return _ref.apply(this, arguments);
      }

      return settlements;
    }()
  }, {
    key: 'settlement',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(transactionHashIndex) {
        var response;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return axios.get(this.endpoint + '/v0/settlements/transactionHashIndex');

              case 2:
                response = _context2.sent;
                return _context2.abrupt('return', settlementFromJSON(response.data.result));

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function settlement(_x2) {
        return _ref2.apply(this, arguments);
      }

      return settlement;
    }()
  }, {
    key: 'assets',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(query) {
        var response;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return axios.get(this.endpoint + '/v0/assets' + objToQuery(query));

              case 2:
                response = _context3.sent;
                return _context3.abrupt('return', response.data.result.map(assetFromJSON));

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function assets(_x3) {
        return _ref3.apply(this, arguments);
      }

      return assets;
    }()
  }, {
    key: 'asset',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(hash) {
        var response;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return axios.get(this.endpoint + '/v0/assets/' + hash);

              case 2:
                response = _context4.sent;
                return _context4.abrupt('return', assetFromJSON(response.data.result));

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function asset(_x4) {
        return _ref4.apply(this, arguments);
      }

      return asset;
    }()
  }, {
    key: 'trackAsset',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(asset) {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', axios.post(this.endpoint + '/v0/assets/track', asset));

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function trackAsset(_x5) {
        return _ref5.apply(this, arguments);
      }

      return trackAsset;
    }()
  }, {
    key: 'orders',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(query) {
        var response;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return axios.get(this.endpoint + '/v0/orders' + objToQuery(query));

              case 2:
                response = _context6.sent;
                return _context6.abrupt('return', response.data.result.map(orderFromJSON));

              case 4:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function orders(_x6) {
        return _ref6.apply(this, arguments);
      }

      return orders;
    }()
  }, {
    key: 'order',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(hash) {
        var response;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return axios.get(this.endpoint + '/v0/orders/' + hash);

              case 2:
                response = _context7.sent;
                return _context7.abrupt('return', orderFromJSON(response.data.result));

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function order(_x7) {
        return _ref7.apply(this, arguments);
      }

      return order;
    }()
  }, {
    key: 'validateOrder',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(order) {
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', axios.post(this.endpoint + '/v0/orders/validate', order));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function validateOrder(_x8) {
        return _ref8.apply(this, arguments);
      }

      return validateOrder;
    }()
  }, {
    key: 'postOrder',
    value: function () {
      var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(order) {
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', axios.post(this.endpoint + '/v0/orders/post', order));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function postOrder(_x9) {
        return _ref9.apply(this, arguments);
      }

      return postOrder;
    }()
  }]);
  return WyvernExchange;
}();

module.exports = { WyvernExchange: WyvernExchange, errors: errors, feeRecipient: feeRecipient };



// WEBPACK FOOTER //
// ./node_modules/wyvern-exchange/dist.js